import TopSection from "../../../CommonComponents/TopSection";
import TuneIcon from "@mui/icons-material/Tune";
import GlobalFilter from "./GlobalFilter";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import ShipmentCard from "./Card/ShipmentCard";
import "./Card.css";
import SearchWidget from "./SearchWidget";
import { Grid, Stack, Typography, useTheme } from "@mui/material";
import { createContext, useCallback, useContext, useState } from "react";
import { useFetchDashboard } from "../../../services/Dashboard";
import { CustomSwitch } from "../../../Components/Switch/CustomSwitch";
import { ConditionalWrapper } from "../../../Components/utils/ConditionalWrapper";
import { ShipmentCardv2 } from "./Card/ShipmentCardv2";
import Tooltip from "@mui/material/Tooltip";
import React from "react";
import { useEffect } from "react";

const defaultCardOrder = [
  {
    id: "Inventory",
    idx: 0,
  },
  {
    id: "Purchase Orders",
    idx: 1,
  },
  {
    id: "Inbound Shipments",
    idx: 2,
  },
  {
    id: "Outbound Shipments",
    idx: 3,
  },
  {
    id: "Sales Orders",
    idx: 4,
  },
];
const CTDashboard = () => {
  const theme = useTheme();
  const [isNew, setIsNew] = useState(false);
  const [globalFilterOpen, setGlobalFilterOpen] = useState(false);
  const loadCardOrder = () =>
    JSON.parse(localStorage.getItem("cardOrder")) || defaultCardOrder;
  const { expandableWidgets } = useWidgetContext();

  const [visibleWidgets, setVisibleWidgets] = useState([]);
  const [items, setItems] = useState(loadCardOrder());
  let dragImg = null;

  const breadcrumbArray = ["Home", "Dashboard"];
  const handleWidgetVisibilityChange = useCallback(
    (visible) => setVisibleWidgets(visible),
    []
  );
  const [shipmentTypes, setShipmentTypes] = useState({
    inbound: true,
    outbound: true,
    loads: true,
  });

  const isCardVisibleForShipmentType = (cardId) => {
  // Inventory always visible
  if (cardId === "Inventory") return true;

  // Inbound related
  if (shipmentTypes.inbound) {
    if (
      cardId === "Inbound Shipments" ||
      cardId === "Purchase Orders"
    ) {
      return true;
    }
  }

  // Outbound related
  if (shipmentTypes.outbound) {
    if (
      cardId === "Outbound Shipments" ||
      cardId === "Sales Orders"
    ) {
      return true;
    }
  }

  return false;
};

  const exceptionsAndState = useFetchDashboard();

  const onDragElement = (e) => {
    console.log("on drag", dragImg);
    if (dragImg) {
      dragImg.style.left = e.clientX + "px";
      dragImg.style.top = 0 + "px";
    }

    const container = document.querySelector(".shipmentCard-container");
    const rect = container.getBoundingClientRect();
    const scrollThreshold = 40;
    const scrollAmount = 40;

    if (e.clientY < rect.top + scrollThreshold) {
      container.scrollTop -= scrollAmount;
    } else if (e.clientY > rect.bottom - scrollThreshold) {
      container.scrollTop += scrollAmount;
    }
  };

  const onDragStartElement = (e) => {
    e.currentTarget.style.opacity = "0.5";
    dragImg = e.currentTarget.cloneNode(true);
    console.log("on drag start", dragImg);
    dragImg.style.opacity = "1";
    dragImg.style.border = "none";
    dragImg.style.position = "fixed";
    dragImg.style.width = e.currentTarget.offsetWidth / 2 + "px";
    dragImg.style.zIndex = "9999";
    dragImg.style.left = e.clientX + "px";
    dragImg.style.top = 0 + "px";
    dragImg.style.transform = "scale(0.5)";
    document.body.appendChild(dragImg);
    const container = document.querySelector(".shipmentCard-container");
    if (container) {
      container.style.transform = "scale(0.5)";
      container.style.transformOrigin = "top center";
      container.style.transition = "transform 0.2s";
      container.style.height = "30%";
    }
    const body = document.querySelector(".shipmentCard-container #card-body");
    if (body) body.style = "min-height:0";

    e.dataTransfer.setData("text", e.currentTarget.id);
    e.dataTransfer.setDragImage(dragImg, e.clientX, e.clientY);
    setTimeout(() => document.body.removeChild(dragImg), 0);
  };

  const onDragLeaveElement = (e) => {
    console.log("on drag leave", e.currentTarget);
    e.currentTarget.style.opacity = "1";
    e.currentTarget.style.border = "none";
  };

  const onDragOverElement = (e) => {
    console.log("on drag over");
    e.preventDefault();
    e.currentTarget.style.opacity = "0.5";
    e.currentTarget.style.border = "4px solid forestgreen";
  };

  const onDropElement = (e) => {
    e.currentTarget.style.opacity = "1";
    e.currentTarget.style.border = "none";
    const draggedId = e.dataTransfer.getData("text");
    console.log("on drop", e.currentTarget);
    const draggedIndex = items.findIndex((item) => item.id === draggedId);
    const targetIndex = items.findIndex(
      (item) => item.id === e.currentTarget.id
    );
    if (draggedIndex !== -1 && targetIndex !== -1) {
      const updatedItems = [...items];
      const [removed] = updatedItems.splice(draggedIndex, 1);
      updatedItems.splice(targetIndex, 0, removed);
      setItems(updatedItems);
      localStorage.setItem("cardOrder", JSON.stringify(updatedItems));
    }
  };

  const onDragEndElement = (e) => {
    const container = document.querySelector(".shipmentCard-container");
    if (container) {
      container.style.transform = "";
      container.style.transformOrigin = "";
      container.style.transition = "";
      container.style.height = "";
    }
    const body = document.querySelector(".shipmentCard-container #card-body");
    if (body) body.style = "min-height:370px;";
    console.log("on drag end");
  };


  const loadExceptions = (id) => {
    switch (id) {
      case "Inventory":
        return exceptionsAndState?.inventoryExceptions;
      case "Purchase Orders":
        return exceptionsAndState?.purchaseOrderExceptions;
      case "Inbound Shipments":
        return exceptionsAndState?.inboundShipmentExceptions;
      case "Outbound Shipments":
        return exceptionsAndState?.outboundShipmentExceptions;
      case "Sales Orders":
        return exceptionsAndState?.salesOrderExceptions;
      default:
        return null;
    }
  };
  const loadExceptionsTotal = (id) => {
    switch (id) {
      case "Inbound Shipments":
        return exceptionsAndState?.inboundShipmentTotalExceptions;
      case "Outbound Shipments":
        return exceptionsAndState?.outboundShipmentTotalExceptions;

      default:
        return null;
    }
  };

  const loadStatesTotal = (id) => {
    switch (id) {
      case "Inbound Shipments":
        return exceptionsAndState?.inboundShipmentTotalStates || [];
      case "Outbound Shipments":
        return exceptionsAndState?.outboundShipmentTotalStates || [];
      default:
        return [];
    }
  };

  const loadStates = (id) => {
    switch (id) {
      case "Inventory":
        return exceptionsAndState?.inventoryStates || [];
      case "Purchase Orders":
        return exceptionsAndState?.purchaseOrderStates || [];
      case "Inbound Shipments":
        return exceptionsAndState?.inboundShipmentStates || [];
      case "Outbound Shipments":
        return exceptionsAndState?.outboundShipmentStates || [];
      case "Sales Orders":
        return exceptionsAndState?.salesOrderStates || [];
      default:
        return [];
    }
  };


  return (
    <div>
      <TopSection
        breadcrumbArray={breadcrumbArray}
        hideHeader={true}
        headerName={""}
      />
      <GlobalFilter open={globalFilterOpen} onClose={() => setGlobalFilterOpen(false)} shipmentTypes={shipmentTypes}
        setShipmentTypes={setShipmentTypes} />
      <div
        style={{
          display: "flex",
          marginTop: -10,
          gap: 20,
          alignItems: "center",
          justifyContent: "center",
        }}
      >

        <Tooltip title={process.env.REACT_APP_ENVT === "DEV" ? "" : "Feature in Progress"} arrow>
          <div
            role="button"
            onClick={() => process.env.REACT_APP_ENVT === "DEV" && setGlobalFilterOpen(true)}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 30,
              height: 30,
              border: "1px solid #8d8a8a",
              borderRadius: 20,
              cursor: process.env.REACT_APP_ENVT === "DEV" ? "pointer" : "default", // Default cursor in production
              opacity: process.env.REACT_APP_ENVT === "DEV" ? 1 : 0.5, // Add visual cue for disabled state
            }}
          >
            <TuneIcon style={{ width: 20, height: 20 }} />
          </div>
        </Tooltip>
        {/* </Tooltip> */}
        <div>
          <TextField
            placeholder="Search"
            size="small"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              },
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderWidth: "1px",
                },
                "&:hover fieldset": {
                  borderWidth: "1px",
                },
                "&.Mui-focused fieldset": {
                  borderWidth: "1px",
                },
                "& input::placeholder": {
                  fontSize: "13px",
                },
              },
            }}
          />
        </div>
        <SearchWidget onVisibilityChange={handleWidgetVisibilityChange} />{" "}
        {process.env.REACT_APP_ENVT === "DEV" && (
          <Stack
            direction="row"
            spacing={1}
            sx={{ alignItems: "center", alignSelf: "center" }}
          >
            <Typography>Old</Typography>
            <CustomSwitch
              checked={isNew}
              onChange={(_, checked) => setIsNew(checked)}
              theme={theme}
            />
            <Typography>New</Typography>
          </Stack>
        )}
      </div>

      <div className="shipmentCard-container">
        <Grid container size={12} spacing={2}>
          {items.map(
  (item) =>
    visibleWidgets.includes(item.id) &&
    isCardVisibleForShipmentType(item.id) && (
      <Grid
        key={item.id}
        className="shipmentCard"
        size={{
          xs: 12,
          sm: expandableWidgets.has(item.id) ? 12 : 6,
          xl: expandableWidgets.has(item.id) ? 6 : 4,
        }}
      >
        <div
          id={item.id}
          draggable
          onDrag={onDragElement}
          onDragStart={onDragStartElement}
          onDragOver={onDragOverElement}
          onDragLeave={onDragLeaveElement}
          onDrop={onDropElement}
          onDragEnd={onDragEndElement}
        >
          <ConditionalWrapper
            condition={isNew}
            elseContent={
              <ShipmentCard
                title={item.id}
                isLoading={!exceptionsAndState}
                exceptions={loadExceptions(item.id)}
                states={loadStates(item.id)}
              />
            }
          >
            <ShipmentCardv2
              title={item.id}
              isLoading={!exceptionsAndState}
              exceptions={loadExceptions(item.id)}
              states={loadStates(item.id)}
            />
          </ConditionalWrapper>
        </div>
      </Grid>
    )
)}
        </Grid>
      </div>
    </div>
  );
};

export default CTDashboard;

export const WidgetContext = createContext({
  expandableWidgets: new Set([]),
  setExpandableWidgets: () => { },
});

export const useWidgetContext = () => useContext(WidgetContext);

export const ExpandableWidget = ({ children }) => {
  const [expandableWidgets, setExpandableWidgets] = useState(new Set([]));
  const updateWidgets = useCallback(
    (widget) =>
      setExpandableWidgets((set) => {
        set.has(widget) ? set.delete(widget) : set.add(widget);
        return new Set(set);
      }),
    []
  );
  return (
    <WidgetContext.Provider
      value={{ expandableWidgets, setExpandableWidgets: updateWidgets }}
    >
      {children}
    </WidgetContext.Provider>
  );
};
